import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { capturarCodigoDeUrl } from './lib/referidos'

// Programa de referidos: si la URL trae `?ref=`, se guarda el código y se anota
// el clic. Va aquí, antes de montar nada, y no dentro de una página concreta: el
// enlace de un afiliado puede apuntar a la portada, a `/planes` o a cualquier
// página de servicios, y un `?ref=` sólo llega en una carga completa —navegando
// por dentro de la aplicación no aparece nunca—, así que con mirarlo una vez al
// arrancar basta.
capturarCodigoDeUrl()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
